import React from 'react'

export default function CloudIcon(props) {
  return (
        <svg viewBox="0 0 512 512" {...props}>
            <g>
                <g>
                    <path d="m409.9,102.3c-6.8-23.4-39.7-91.3-121.2-91.3-76.4,0-110.2,61.7-117.7,81-12.6-4.4-25.8-6.6-39.3-6.6-66.5,0-120.7,54.6-120.7,121.6s54.2,121.6 120.8,121.6h63.6c11.3,0 20.4-9.2 20.4-20.5s-9.1-20.5-20.4-20.5h-63.6c-44.1,0-80-36.1-80-80.5s35.9-80.5 80-80.5c14.8,0 29.2,4.1 41.8,11.9 16.2,9.9 28.3,0.4 30.8-14.2 7.2-41.7 42.2-72.1 84.4-72.1 42.1,0 77.6,30.3 84.4,72.1 1.5,9.5 9.4,16.6 18.9,17.2 38.3,2.3 68.3,34.4 68.3,73.1 0,40.4-32.6,73.2-72.7,73.2h-62.6c-11.3,0-20.4,9.2-20.4,20.5s9.1,20.5 20.4,20.5h62.6c62.6,0 113.5-51.2 113.5-114.2-0.2-55.3-39.1-101.7-91.3-112.3z" />
                    <path d="m318.7,409c-8.5-7.4-21.3-6.5-28.6,2l-13.1,15.1v-236.1c0-11.3-9.1-20.4-20.3-20.4-11.2,0-20.3,9.1-20.3,20.4v236l-13-15c-7.4-8.5-20.2-9.4-28.6-2-8.4,7.4-9.3,20.3-2,28.8l48.6,56.2c3.9,4.5 9.4,7 15.3,7 5.9,0 11.4-2.6 15.3-7l48.6-56.2c7.4-8.5 6.5-21.4-1.9-28.8z" />
                </g>
            </g>
        </svg>
  )
}
